

import api from './api';

export const getLabProfiles = () => api.getLabProfiles();
export const getLabProfileById = (id) => api.getLabProfileById(id);
export const createLabProfile = (data) => api.createLabProfile(data);
export const updateLabProfile = (id, data) => api.updateLabProfile(id, data);
